
import { Component, Emit, Prop, Ref, Vue, Watch } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'
import { getStickerPathByPattern } from '@xt/client/utils/sticker'
import EmojiInput from '../input/Emoji.vue'
import StickerInput from '../input/Sticker.vue'

@Observer
@Component({
  components: { EmojiInput, StickerInput }
})
export default class ContentInputBar extends Vue {
  @Prop({ required: true }) visible: boolean

  @Prop({ required: true }) placeholder: string

  @Ref()
  inputRef: { $el: HTMLTextAreaElement }

  value: string = ''
  stickers: string[] = []

  loading = false

  // 暴露给父组件使用
  updateLoading(isLoading: boolean) {
    this.loading = isLoading
  }

  handleSelectSticker(pattern: string) {
    if (this.stickers.length >= 3) {
      this.$message.error('不能选更多了 😮‍💨')
      return
    }

    this.stickers.push(pattern)
  }

  handleInput() {
    const regex = /(\n){3,}/g
    this.value = this.value.replace(regex, '\n\n')
  }

  handleSelectEmoji(emoji: string) {
    if (this.inputRef?.$el) {
      const { selectionStart = 0 } = this.inputRef.$el

      this.value = this.value.slice(0, selectionStart) + emoji + this.value.slice(selectionStart)
      const nextSelectionStart = selectionStart + emoji.length

      this.$nextTick(() => {
        this.inputRef.$el.setSelectionRange(nextSelectionStart, nextSelectionStart)
      })
    } else {
      this.value = this.value + emoji
    }

    if (this.inputRef) {
      this.inputRef.$el.focus()
    }
  }

  getStickerPathByPattern(pattern) {
    return getStickerPathByPattern(pattern)
  }

  handleRemoveSticker(index: number) {
    this.stickers.splice(index, 1)
  }

  handleTransitionEnd() {
    if (this.visible && this.inputRef) {
      this.inputRef.$el.focus()
    } else if (!this.visible) {
      // 清除数据
      this.loading = false
      this.value = ''
      this.stickers = []

      this.$emit('closed')
    }
  }

  handleClickSend() {
    this.$emit('send', {
      value: this.value,
      stickers: this.stickers
    })
  }

  created() {}
  mounted() {}
  updated() {}
  destroyed() {}
}
